import { Axios } from "../lib/axios";
export const FaqServices = {
  getFaqs,
};
function getFaqs() {
  return Axios.get("/faqs/getAll");
}
